import * as React from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../resources/images/Logo unicolore bleu.svg";
import logo_art from "../resources/images/logo_ART.jpg";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";

interface IHeaderNavBarProps extends WithTranslationLangProps {
  transparency: boolean;
}

class HeaderNavBar extends React.Component<IHeaderNavBarProps> {
  public static defaultProps = {
    transparency: false,
  };

  render() {
    let rootClasses = "header-navbar bg-title";
    if (this.props.transparency) rootClasses += " back-opacity-09";
    return (
      <Navbar
        fixed="top"
        collapseOnSelect
        expand="md"
        variant="dark"
        className={rootClasses}
      >
        <Navbar.Brand href="/">
          <img
            alt="previseo logo"
            src={logo}
            className="d-inline-block align-top navbar-brand-logo"
          />
          <span className="navbar-brand-name">Previseo</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <Link className="nav-link" to="/">
              {this.props.t("plan_a_trip")}
            </Link>
          </Nav>
          <Nav>
            <Link className="nav-link" to="/map">
              {this.props.t("map")}
            </Link>
          </Nav>
          <Nav>
            <Link className="nav-link" to="/about">
              {this.props.t("about")}
            </Link>
          </Nav>
        </Navbar.Collapse>
        <Navbar.Brand href="https://www.autorite-transports.fr/" target="_blank">
          <img
            alt="ART logo"
            src={logo_art}
            className="d-inline-block align-top navbar-brand-logo"
          />
        </Navbar.Brand>
      </Navbar>
    );
  }
}

export default withTranslation()(HeaderNavBar);
